<template>
    <div>
      {{ getData() }}
    </div>
  </template>
  
  <script>
  import erm from '@/components/UIComponents/EventDataRenderers/EventRenderersMethods.js'
  
  export default {
    name: 'TtsTooManyButtonPressesRenderer',
    props: {
      eventType: {
        type: String,
        required: true,
      },
      eventData: {
        type: String,
        required: true,
      }
    },
    methods: {
      getData() {
          let numberOfPresses = erm.getValueOutOfGivenKey('numberOfPresses', this.eventData);
          let nMinutes = erm.getValueOutOfGivenKey('nMinutes', this.eventData);
          let template = erm.getTranslationForEventDescription(this.eventType);

          if (!numberOfPresses || !nMinutes || !template) {
              return this.eventData;
          }

          return this.replacePlaceholders(template, numberOfPresses, nMinutes);
      },
      replacePlaceholders(template, numberOfPresses, nMinutes) {
        template = template.replace("{numberOfPresses}", numberOfPresses);
        template = template.replace("{nMinutes}", nMinutes);
        return template;
      }
    }
  };
  </script>